import React from 'react';

import GroupStatusChip from 'components/Chips/GroupStatusChip';

import { StyledMenuItem, StyledSelect } from '../styles';
import { GroupStatusSelectProps, GroupStatusValue } from './types';

const OPTIONS: GroupStatusValue[] = ['active', 'inactive'];

const GroupStatusSelect: React.FunctionComponent<GroupStatusSelectProps> = ({ onChange, ...props }) => (
  <StyledSelect {...props} fullWidth onChange={(event) => onChange(event.target.value as GroupStatusValue)}>
    {OPTIONS.map((status) => (
      <StyledMenuItem key={status} value={status}>
        <GroupStatusChip isActive={status === 'active'} />
      </StyledMenuItem>
    ))}
  </StyledSelect>
);

export default GroupStatusSelect;
